 import * as React from "react"

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select"

export type CustomSelectItemsType = {label: string, value:string }[]

export function CustomSelectGroup({
  name,
  placeholder,
  items,
  label,
  value,
  defaultValue,
  onChange,
}:{
  name: string;
  items: CustomSelectItemsType;
  placeholder: string;
  label?: string;
  value?: any;
  defaultValue?: any;
  onChange: (value: string) => void;
}) {
  return (
    <Select
      name={name}
      value={value}
      defaultValue={defaultValue}
      onValueChange={onChange}
      className="border-2 border-gray-300 h-10 w-full bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent focus-visible:outline-none focus-visible:border-2 focus-visible:border-blue-500">
      <SelectTrigger className="border border-gray-300 h-10 w-full bg-transparent px-3 py-1 text-base shadow-sm transition-colors file:border-0 file:bg-transparent">
        <SelectValue placeholder={placeholder ?? ""} />
      </SelectTrigger>
      <SelectContent>
        <SelectGroup>
          {/*<SelectLabel>{label}</SelectLabel>*/}
          {items.map((item, index: number) => (
            <SelectItem key={`s-name-${index}`} value={String(item.value)}>
              {item.label}
            </SelectItem>
          ))}
        </SelectGroup>
      </SelectContent>
    </Select>
  )
}

export default CustomSelectGroup